import {useMutation} from 'react-query';
import {postPromotionCartToCart} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IUsePostPromotionCartToCartProps {
  onSuccess?: () => void;
}
const usePostPromotionCartToCart = ({
  onSuccess,
}: IUsePostPromotionCartToCartProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPromotionCartToCartPayload) => {
      return postPromotionCartToCart(payload);
    },
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostPromotionCartToCart;
